module.exports = __webpack_public_path__ + "static/media/__statistics.95590b4f.svg";